<div class="relative w-full">
  <mat-form-field class="w-full">
    <mat-label>{{ label }}</mat-label>
    <textarea
      title="Message"
      #textareaEl
      [formControl]="internalControl"
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      role="combobox"
      aria-autocomplete="list"
      aria-haspopup="listbox"
      [attr.aria-expanded]="showMentionPanel && mentionResults.length > 0"
      [attr.aria-controls]="mentionResults.length ? listboxId : null"
      [attr.aria-activedescendant]="activeOptionId"
      (focus)="onTextareaFocus()"
      (input)="onMessageInput($event)"
      (keydown)="onMentionKeydown($event)"
      (keyup)="onMessageKeyup($event)"
      (click)="onMessageInput($event)"
      (blur)="onBlur()"
    ></textarea>
  </mat-form-field>

  <!-- Announces result-count changes to screen readers — aria-activedescendant alone only
       identifies the current option, it doesn't tell the user how many there are or that the
       set changed as they kept typing. -->
  <div class="visually-hidden" aria-live="polite">
    <ng-container *ngIf="showMentionPanel">
      {{ mentionResults.length }} mention suggestion{{ mentionResults.length === 1 ? '' : 's' }} available
    </ng-container>
  </div>

  <!--
    Hand-rolled dropdown instead of Angular Material's MatAutocomplete (already used
    elsewhere, e.g. profile.component.ts's ppa picker). This was a deliberate choice, not
    an oversight: MatAutocompleteTrigger does support attaching to a <textarea> in this
    Material version, but its whole model is "the selected option becomes the entire
    control's value" (see _setTriggerValue in @angular/material/autocomplete). An inline
    @mention needs the opposite — insert a token at the caret and keep everything else the
    user already typed — so using it here would mean overriding that default write on
    every single selection rather than benefiting from it: more complexity and more risk
    for a dubious consistency win. (This is also why Slack/Discord's own web clients don't
    use their platform's value-replacing autocomplete widgets for inline mentions either.)
    Viewport-edge collision (the concrete, valid part of that concern) is handled instead
    via mentionPanelPosition — see computeMentionPanelPosition() in the component.
  -->
  <ul
    *ngIf="showMentionPanel && mentionResults.length"
    [id]="listboxId"
    role="listbox"
    aria-label="Mention suggestions"
    class="mention-autocomplete-panel"
    [style.max-height.px]="mentionPanelMaxHeight"
    [class.mention-autocomplete-panel--below]="mentionPanelPosition === 'below'"
  >
    <li
      *ngFor="let member of mentionResults; let i = index"
      [id]="optionId(i)"
      role="option"
      [appMentionOption]="member"
      class="mention-autocomplete-option"
      (mousedown)="$event.preventDefault(); selectMention(member)"
    >
      <app-avatar
        class="size-5 text-[9px]"
        [photoUrl]="member?.Media?.url"
        [entity]="member"
      ></app-avatar>
      <span class="text-sm">{{ mentionName(member) }}</span>
    </li>
  </ul>
</div>
